import { PhoneCall } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useCallConfig } from '@/modules/calls/hooks/useCalls'
import { useCallStore } from '@/modules/calls/store/call.store'
import { cn } from '@/utils/cn'

/** App-wide strip while a call still needs its result (blocks the next call). */
export function PendingCallBanner({ className }: { className?: string }) {
  const { data: config } = useCallConfig()
  const openOutcome = useCallStore((s) => s.openOutcome)
  const outcomeOpen = useCallStore((s) => Boolean(s.outcomeCallId || s.desktopCall))
  const pending = config?.pendingWrapUps[0]

  if (!pending || outcomeOpen) return null

  return (
    <div
      role="status"
      className={cn(
        'flex shrink-0 items-center gap-2 border-b border-amber-500/30 bg-amber-500/10 px-3 py-2 text-sm text-foreground',
        className,
      )}
    >
      <PhoneCall className="h-4 w-4 shrink-0 text-amber-600 dark:text-amber-400" aria-hidden />
      <p className="min-w-0 flex-1 truncate font-medium">Finish call: {pending.lead?.businessName ?? pending.callNo}</p>
      <Button type="button" size="sm" className="h-8 shrink-0 px-3" onClick={() => openOutcome(pending.id)}>
        Save result
      </Button>
    </div>
  )
}
